// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Stimulusをロード
import { Application } from "@hotwired/stimulus"

// tailwindcss-stimulus-componentsをインポート
import { Slideover } from "tailwindcss-stimulus-components"

// Stimulus コントローラーの登録
const application = Application.start()

// tailwindcss-stimulus-componentsの登録
application.register('slideover', Slideover)
console.log('[Stimulus] slideover component registered from tailwindcss-stimulus-components')

// コントローラーの自動登録
const controllers = import.meta.glob("../javascript/controllers/*_controller.js", { eager: true })
for (const path in controllers) {
  const controllerName = path.replace(/^.*\/(.+)_controller\.js$/, '$1')
  // スネークケースからケバブケースに変換
  const kebabCaseName = controllerName.replace(/_/g, '-')
  application.register(kebabCaseName, controllers[path].default)
  console.log('[Stimulus]', kebabCaseName, ' controller registered.')
}

// Turbo Railsのロード
import "@hotwired/turbo-rails"

// CSSファイルのインポート
import "../resources/sortable.css"
